export default function DateInput({ handleDateChange, label, value, width }) {
  return (
    <div className={`sm:col-span-${width || 1}`}>
      <label
        htmlFor="date-input"
        className="block text-sm font-medium leading-6 text-zinc-900 dark:text-zinc-100"
      >
        {label ?? "Date Input"}
      </label>
      <input
        type="date"
        name="date-input"
        id="date-input"
        className="mt-1 block w-full rounded-md dark:bg-zinc-800 dark:ring-zinc-800 dark:text-zinc-100 border dark:border-none border-zinc-300 shadow-sm focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm"
        value={value}
        onChange={handleDateChange}
      />
    </div>
  );
}
